import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Box from '@mui/system/Box'
import Typography from '@mui/material/Typography'
import Icon from '@mui/material/Icon'
import CardMedia from '@mui/material/CardMedia'

// Local imports
import { iconConstructor } from '../../functions'
import defaultAvatar from 'assets/images/default_avatar.png'

const LeavePendingList = ({
  id,
  type,
  title,
  subtitle,
  startDate,
  endDate,
  user,
  imgUrl,
  amount,
  requestId,
}) => {
  const navigate = useNavigate()
  const backgroundLocation = useLocation()

  return (
    <Box
      width={1}
      bgcolor="white.main"
      paddingX={{ xs: 2, lg: 3 }}
      paddingY={{ xs: 2, lg: 2 }}
      boxSizing="border-box"
      sx={{
        boxShadow: 'none',
        borderBottom: 1,
        borderColor: 'gray-line.main',
      }}
      onClick={() =>
        navigate(`/app/approval-center/leave/request/${id}`, {
          state: {
            backgroundLocation,
            data: {
              id,
              type,
              title,
              subtitle,
              startDate,
              endDate,
              user,
              imgUrl,
              amount,
              requestId,
            },
          },
        })
      }
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ cursor: 'pointer' }}
      >
        <Box width={{ xs: 1, lg: 4 / 5 }} display="flex" alignItems="center" columnGap={2}>
          <Box display="flex" justifyContent="center" alignItems="center" width={90} height={90}>
            <Box position="relative" width={80} height={80}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  height: 52,
                  width: 52,
                  bgcolor: 'alternate.light',
                  objectFit: 'cover',
                  borderRadius: '50%',
                }}
              >
                <Icon
                  sx={{
                    fontSize: 26,
                    color: 'alternate.main',
                  }}
                >
                  {iconConstructor(type)}
                </Icon>
              </Box>
              <CardMedia
                component="img"
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  right: 0,
                  height: 52,
                  width: 52,
                  bgcolor: 'gray-background.main',
                  objectFit: 'cover',
                  borderRadius: '50%',
                  border: '3px solid',
                  borderColor: 'white.main',
                }}
                alt={user}
                src={imgUrl || defaultAvatar}
              />
            </Box>
          </Box>
          <Box
            width={{ xs: 1, lg: 'calc(100% - 100px)' }}
            // height={85}
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            gap={1.5}
          >
            <Box>
              <Typography
                noWrap
                component="span"
                variant="body1"
                color="dark-gray.main"
                fontWeight="bold"
                textTransform="capitalize"
              >
                {title}
              </Typography>
              <Box display={'flex'} alignItems={'center'} columnGap={1.5} mt={0.5}>
                {subtitle && (
                  <>
                    <Typography
                      display={
                        (type === 1 || type === 2) && {
                          xs: 'none',
                          lg: 'block',
                        }
                      }
                      component="span"
                      variant="body2"
                      color="light-gray-text.main"
                      textTransform="capitalize"
                    >
                      {subtitle}
                    </Typography>
                    <Icon
                      sx={{
                        display: { xs: 'none', lg: 'block' },
                        fontSize: 7,
                        color: 'light-gray-text.main',
                      }}
                    >
                      circle_rounded
                    </Icon>
                  </>
                )}
                <Typography
                  display={type === 3 && { xs: 'none', lg: 'block' }}
                  // width={1}
                  noWrap
                  component="span"
                  variant="body2"
                  color="light-gray-text.main"
                  textTransform="capitalize"
                >
                  {startDate} - {endDate}
                </Typography>
              </Box>
            </Box>
            <Typography
              display={{ xs: 'none', lg: 'block' }}
              width={6 / 7}
              minWidth={400}
              variant="body2"
              color="light-gray-text.main"
              textTransform="capitalize"
            >
              Requester: {user}
            </Typography>
            <Typography
              display={{ xs: 'flex', lg: 'none' }}
              noWrap
              component="span"
              variant="h4"
              fontWeight="bold"
              color="alternate.main"
              sx={{
                textDecoration: 'underline',
              }}
            >
              {amount} {amount === 1 ? 'day' : 'days'}
            </Typography>
          </Box>
        </Box>
        <Box
          width={1 / 5}
          display={{ xs: 'none', lg: 'flex' }}
          justifyContent="end"
          alignCenter="center"
          columnGap={1}
        >
          <Typography
            noWrap
            component="span"
            variant="h4"
            fontWeight="bold"
            color="alternate.main"
            sx={{
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
          >
            {amount} {amount === 1 ? 'day' : 'days'}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default LeavePendingList
